export default (isBloqueado) => {
	if (isBloqueado) {
		return 'Bloqueado'
	}
	return 'Desbloqueado'
}
